import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';

import { faTimes } from '@fortawesome/free-solid-svg-icons';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';

import { env } from '../../config';

const FieldsArticleGen = ({ fileUploadUrl, defaultContent }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  // Map i18n language codes to config keys
  const getLangKey = (isType = false) => {
    if (language === 'en') return 'en';
    // For article types, use 'zh', for subjects use 'zhhk'
    return isType ? 'zh' : 'zhhk';
  };

  return (
    <>
      <div className="row">
        <div className="col">
          <FormGroup
            name="pdfURL"
            as="upload"
            api="/api/quiz/articles/files"
            label={t('PDF 上傳')}
            fileOpts={{ accept: 'application/pdf' }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup name="refCode" label={t('Reference Code')} required />
          <FormGroup name="title" label={t('Title')} required />
          <FormGroup
            name="tags"
            label={`${t('Tags')} (${t('Comma seperated')})`}
          />
          <div className="form-group">
            <FormGroup name="type" as="select" label={t('type')}>
              <option value=""> - </option>
              {Object.keys(env.type).map((key) => (
                <option value={key} key={key}>
                  {env.type[key][getLangKey(true)]}
                </option>
              ))}
            </FormGroup>
          </div>
          <div className="form-group">
            <label>{t('Subjects')} *</label>
            {Object.keys(env.subjects).map((key) => (
              <FormCheckGroup
                key={key}
                name="subjects"
                type="checkbox"
                value={key}
                label={env.subjects[key][getLangKey(false)]}
              />
            ))}
          </div>
        </div>
        <div className="col">
          <FormGroup
            name="coverImg"
            as="coverImg"
            label={`${t('Cover Image')} (${t(
              'Suggested Dimension',
            )}: 1200 x 675px)`}
            api={fileUploadUrl}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup
            name="extraReading.coverImg"
            as="coverImg"
            label={t('Extra Reading') + t('Cover Image')}
            api={fileUploadUrl}
          />
        </div>
        <div className="col">
          <FormGroup
            name="extraReading.url"
            label={t('URL')}
            placeholder="eg: https://chiculture.org.hk/tc"
          />
          <FormGroup name="extraReading.title" label={t('Title')} />
          <FormGroup name="extraReading.caption" label={t('Caption')} />
        </div>
      </div>
      <FormGroup
        name="content"
        label={t('Content')}
        as="summernote"
        fileUploadUrl={fileUploadUrl}
      />

      <FieldArrayIterables name="contents" push={defaultContent}>
        {(q, i, { remove }) => (
          <div key={i} className="card mb-3 p-3">
            <button className="btn btn-link close" onClick={() => remove(i)}>
              <FA icon={faTimes} size="sm" />
            </button>
            <div className="card-body">
              <div className="row">
                <div className="col">
                  <FormGroup
                    name={`contents.${i}.content`}
                    label={t('Content')}
                    as="summernote"
                    fileUploadUrl={fileUploadUrl}
                  />
                </div>
                <div className="col">
                  <FormGroup
                    className="contain"
                    name={`contents.${i}.img`}
                    as="coverImg"
                    label={
                      <>
                        {t('Image')} ({t('Suggested Dimension')}: 1280 x 960px)
                      </>
                    }
                    api={fileUploadUrl}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <FormGroup
                    as="select"
                    name={`contents.${i}.animation`}
                    label="Animation"
                  >
                    <option value={null}>-</option>
                    <option value="fade-out">{t('Fade Out')}</option>
                    <option value="slide-down">{t('Slide Down')}</option>
                  </FormGroup>
                </div>
              </div>
            </div>
          </div>
        )}
      </FieldArrayIterables>
      <FormGroup
        name="keyLearning"
        label={t('Key Learning')}
        as="summernote"
        fileUploadUrl={fileUploadUrl}
      />
    </>
  );
};

export default FieldsArticleGen;
